import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorContentBannerView = () => {
  const bannerView = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/content-banner/view', payload, response => {
      if (response.status_code === 200) {
        loading(false)
        callback(response.data)
      }
    })
  }, [])
  return { bannerView }
}

export default InteractorContentBannerView
